var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"start"},[_c('div',{staticClass:"start__intro"},[_c('Intro',{attrs:{"heading":"Beställ e-faktura","description":"Uppge vilken bank du har."}})],1),_vm._v(" "),_c('div',{staticClass:"start__form"},[_c('Form')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7aa0a3d8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/templates/views/Start/index.vue
// module id = null
// module chunks = 